// 設定（メーカーの CREATE_CONFIG）と決まった値（2026-10-21 に app.js から分けた）

export const NS = 'http://www.w3.org/2000/svg';
export const SIZE = 500;          // パーツの座標の大きさ（chibi.SIZE_CHARAT_IMAGE）
export const ICON = 240;          // カテゴリ画像の大きさ（chibi.SIZE_CATEGORY_IMAGE）
// メーカーの設定（page.php の window.CREATE_CONFIG。メーカーの {メーカー}/create/index.php の $ui。無い項目は CHOCO の値。2026-10-20）
import type { CreateConfig } from './types.js';

export const CONFIG: CreateConfig = window.CREATE_CONFIG || {};
export function conf<K extends keyof CreateConfig>(key: K, def: NonNullable<CreateConfig[K]>): NonNullable<CreateConfig[K]>;
export function conf<K extends keyof CreateConfig>(key: K, def: null): CreateConfig[K] | null;
export function conf<K extends keyof CreateConfig>(key: K, def: CreateConfig[K] | null) { return CONFIG[key] !== undefined ? CONFIG[key] : def; }
export const DIR = conf('dir', 'chibi');    // URL のメーカーのディレクトリ
export const SERVICE = conf('save', 'chibi'); // 保存キー（{save}_auto・{save}_save・{save}_agree・スロット）。CHOCO は chibi
// 名前を付けられるか（Rouge・Blanc はクラシック版に名前の入力が無いので false。2026-07-19 に台詞を荒らし対策で廃止したもの。保存データの名前は消さずにそのまま残す）
export const NAME_ON = conf('name', true);
export const ZOOM_STEP = 0.02, ZOOM_MAX = 0.2; // 拡大・縮小（btnSubExpand と同じ）
// うすさ（不透明度）を変えられるカテゴリ: メイク・ペイント・エフェクト・めがね・はね（本物では kawaii・dressup2 のメイクなどにだけある。
// CHOCO のデータには可否が無いので、薄くして意味のあるものにした）。つまみは 10〜100%（0 にすると見えなくなって分からないので 10% まで）
export const OPACITY_KEYS = conf('opacityKeys', ['make', 'facepaint', 'facepaint2', 'bodypaint', 'bodypaint2', 'ef', 'ef2', 'glass', 'wing', 'wing2']);
export const OPACITY_MIN = 10;
